(function () {
    "use strict";

    angular.module("app").directive("validateEmailDomain", ValidateEmailDomainAttribute);

    ValidateEmailDomainAttribute.$inject = ["$q", "validation"];
    function ValidateEmailDomainAttribute($q, validation) {
        return {
            require: "ngModel",
            restrict: "A",
            link: function (_scope, element, _attrs, ctrl) {
                if (!element.type === "email")
                    return;

                ctrl.$validators.email = function (_modelValue) {
                    // Reset email validation to browser validation cfr email-field
                    return element[0].checkValidity();
                };

                ctrl.$asyncValidators.emailDomain = function (_modelValue, viewValue) {
                    const localPromise = $q.defer();

                    if (!viewValue || ctrl.$pristine) {
                        // Resolve the promise if the field is empty or the model is pristine, otherwise we break the required validator
                        localPromise.resolve();
                        return localPromise.promise;
                    }
                    console.log("validating", viewValue, _modelValue);
                    validation.Email(
                        { Email: viewValue },
                        r => {
                            const result = r.data;
                            if (!result.IsValid)
                                localPromise.reject(result.ValidationErrors[0]);
                            else
                                localPromise.resolve();
                        },
                        // If the call to the backend fails we simply accept the result
                        () => localPromise.resolve(),
                        angular.noop
                    );

                    return localPromise.promise;
                };
            }
        };
    }
})();
